<template>
  <div class="partner">
    <div class="part-main">
      <div class="part-title" data-aos="fade-up" data-aos-duration="1000">
        <h3>生态伙伴</h3>
        <P>赋能伙伴，共建未来生态</P>
      </div>
      <div class="part-wrap" style="height:150px ;position: relative; " data-aos="fade-up" data-aos-duration="1000"  data-aos-delay="200">
        <swiper :options="swiperOption">
          <swiper-slide class="swiper-item">
            <img
              src="../../../assets/home/partners/7中国电信1.png"
              alt
              style="width:134px;height:37px;"
            />
          </swiper-slide>
          <swiper-slide class="swiper-item">
            <img
              src="../../../assets/home/partners/liantong@2x.png"
              alt
              style="width:80px;height:40px;"
            />
          </swiper-slide>
          <swiper-slide class="swiper-item">
            <img
              src="../../../assets/home/partners/zhongguoyidong-caise@2x.png"
              alt
              style="width:117px;height:36px;"
            />
          </swiper-slide>
          <swiper-slide class="swiper-item">
            <img
              src="../../../assets/home/partners/中国铁通@2x.png"
              alt
              style="width:150px;height:50px;"
            />
          </swiper-slide>
          <swiper-slide class="swiper-item">
            <img
              src="../../../assets/home/partners/aryaka.png"
              alt
              style="width:139px;height:52px;"
            />
          </swiper-slide>
          <swiper-slide class="swiper-item">
            <img
              src="../../../assets/home/partners/11教育网@2x.png"
              alt
              style="width:120px;height:41px;"
            />
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev">
          <i class="iconfont icon-zuoyou1"></i>
        </div>
        <div class="swiper-button-next">
          <i class="iconfont icon-zuoyou"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: { swiper, swiperSlide },

  data() {
    return {
      swiperOption: {
        slidesPerView: 6,
        spaceBetween: 30,
        autoplay: {
          disableOnInteraction: false
        },
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  }
};
</script>
<style lang="less" scoped>
.partner {
  width: 100%;
  min-width: 1200px;
  background-color: #fff;
  padding-top: 50px;
  padding-bottom: 40px;

  .swiper-container {
    width: 100%;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  .swiper-slide {
    width: 150px;
    height: 50px;
    text-align: center;
    font-size: 18px;
    transition: all 0.3s;
    border-radius: 5px;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: 30px;
    height: 60px;
    line-height: 50px;
    font-size: 22px;
    color: #9b9191;
    outline: none;
    border: 1px solid #f8f5f5;
    background-image: none;
    transition: all 0.3s;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 18px;
    &:hover {
      border: 1px solid #c3191f;
      color: #c3191f;
    }
  }
  .swiper-button-prev {
    left: -30px;
  }
  .swiper-button-next {
    right: -30px;
  }
}
.part-main {
  height: 100%;
  width: 1200px;
  margin: 0 auto;
  .part-title {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 40px;
    text-align: center;
    padding-top: 50px;

    h3 {
      font-size: 28px;
      color: #3b3435;
    }
    p {
      margin-top: 20px;
      font-size: 16px;
      font-weight: 300;
      color: #aba1a2;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/home/components/partner.vue